module.exports = __webpack_public_path__ + "static/media/add_circle.0754f1a8.svg";